import { render, staticRenderFns } from "./HrTrainCertPrac.vue?vue&type=template&id=19d04396&scoped=true&"
import script from "./HrTrainCertPrac.vue?vue&type=script&lang=js&"
export * from "./HrTrainCertPrac.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d04396",
  null
  
)

export default component.exports